import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { Spring } from 'react-spring';
import { history } from '../../helpers/history';
import SaayaLogo from '../../static/images/saayalogo.png';
import AlfalahLogo from '../../static/images/alfalahlogo.png';
import PakQatarLogo from '../../static/images/pakqatarlogo.png';
import Footer from '../../components/Footer/footer';
import saayaLogo from '../../static/images/saaya_logo.png';
import { authActions } from '../../store/actions';
import { emailSent } from '../../helpers/ConstantID';
import { constants } from '../../Constants';
import { contactUsEmail } from '../../config';
import defaultImage from '../../static/images/default_BG.png';

class ConfirmationPassword extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email_address: '',
			reset_api_called: false,
			is_mobile: false,
		};
	}

	componentDidMount() {
		this.props.location.state && this.setState({ email_address: this.props.location.state.email });
		window.innerWidth <= 700 ? this.setState({ is_mobile: true }) : this.setState({ is_mobile: false });
	}

	redirectToSignIn() {
		history.replace('/');
	}

	handleResendSubmit = () => {
		if (this.state.email_address) {
			const { email_address } = this.state;
			const { dispatch } = this.props;
			dispatch(authActions.forgotPasswordEmail(email_address));
			this.setState({ reset_api_called: true });
		} else {
			history.replace('/');
		}
	};

	render() {
		const { email_address, reset_api_called } = this.state;
		const {whitelabel} = this.props;	
		return (
			<div className="sh-layout">
				<div className="sh-email-confirm-comp">
					<div className="sh-gnrl-inner">
						<div className="sh-gnrl-logo">
							{ 
								<img src={whitelabel ? whitelabel[0].logo_url : defaultImage} alt="logo" id={emailSent.sh_es_logo} />
							}
						</div>
						<div className="sh-ecc-heading">
							<h2 className="sh-ecc-h2" id={emailSent.sh_es_text1}>
								{constants.SENT_LINK}
							</h2>
							<p className="sh-ecc-gnrl-text sh-mb-20" id={emailSent.sh_es_text2}>
								{constants.EMAIL_CONFIRM_MSG.replace('{0}', 'reset your password')}
							</p>
						</div>
						<div className="sh-ecc-form">
							<div className="sh-gnrl-row sh-mb-10">
								<button
									id={emailSent.sh_es_btn}
									className="sh-gnrl-btn sh-login-btn"
									onClick={this.redirectToSignIn}
								>
									{constants.SIGN_IN}
								</button>
							</div>

							<div className="sh-gnrl-row">
								<label htmlFor={emailSent.sh_es_cs_btn} className="sh-ecc-cnslr">
									{constants.EMAIL_CONFIRMATION_TXT}
									<a className="mobile-contact-help" href={`mailto:${contactUsEmail}`}>
										{constants.CUSTOMER_SUPPORT_TXT}
									</a>
								</label>
								<button
									className="sh-ecc-cnslr-btn"
									onClick={() => {
										console.log('this is button click');
									}}
									id={emailSent.sh_es_cs_btn}
								></button>
							</div>
						</div>
					</div>
				</div>
				<Footer />
			</div>

					);
	}
}

function mapStateToProps(state) {
	const { authstate } = state.auth;
	const { whitelabel } = state.whitelabel;
	return {
		authstate,
		whitelabel
	};
}

export default withRouter(connect(mapStateToProps)(ConfirmationPassword));



// WEBPACK FOOTER //
// ./src/components/ConfirmationPassword/index.js